exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invite[data-v-056f5400]{margin:21px 0 27px}@media screen and (min-width:641px){.invite[data-v-056f5400]{margin:36px 0 27px}}.invite__inputs[data-v-056f5400]{margin-bottom:25px;display:-ms-grid;display:grid;row-gap:12px}@media screen and (min-width:641px){.invite__inputs[data-v-056f5400]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr);column-gap:27px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-056f5400","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/invite/form/InviteForm.vue
// module id = 75864fe35b025e816123
// module chunks = 22